import React, { useEffect } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect, useSelector } from 'react-redux';
import { get } from 'lodash';
import { createStructuredSelector } from 'reselect';
import { translate } from 'helpers/intl';
import { StyledMediumSectionHeader } from 'containers/AutoDetailsPage/styles';
import messages from 'containers/MRHDetailsPage/messages';
import DetailPageLayout from 'components/DetailPageLayout';
import { StyledShortBody } from 'containers/AUTODashboard/Body/FrequentlyAskedQuestions/styles';
import { sanlamDarkBlue } from 'Material-UI/colors';
import { AssuranceIcon } from 'images';
import FrequentlyAskedQuestions from 'containers/AUTODashboard/Body/FrequentlyAskedQuestions';
import MyContractAndGarantiesTab from 'containers/MRHDetailsPage/MyContractAndGarantiesTab';
import SuivreSinistreMrhTab from 'containers/MRHDetailsPage/SuiviSinistreMrh';
import ContainerTabs from 'components/ContainerTabs';
import MyOffersBloc from 'containers/MRHDetailsPage/MyOffers';
import PreventionGuide from 'containers/MRHDetailsPage/PreventionGuide';
import ServicesBlock from 'containers/MRHDetailsPage/ServicesBlock';
import Breadcrumbs from 'components/Breadcrumbs';
import { setMrhDetailsPageBreadcrumbsPath, getFaq } from 'store/global/actions';
import {
  getMrhDetailsPageBreadcrumbsPathSelector,
  getMrhFaqSelector,
} from 'store/global/selectors';
import { breadcrumbsItemType } from 'store/global/types';
import { getContractsMrhSelector } from 'store/contract/selectors';
import { getDetailsContractMrh, getContractsMrh } from 'store/contract/actions';
import { getMrhDetailsPageSelectedTabValue } from 'store/global/selectors';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import pages from 'routes/pages';

const tabItems = [
  {
    label: 'suiviDeSinistre',
    content: <SuivreSinistreMrhTab />,
  },
  {
    label: 'contractEtGarantie',
    content: <MyContractAndGarantiesTab />,
    gaLabel: 'Mes contrats et garanties',
    category: EVENT_CATEGORIES.MRH_DETAILS,
  },
];
const MRHDetailsPage = (props: {
  intl: IntlShape;
  detailsPageBreadcrumbsPath: breadcrumbsItemType[];
  setMrhDetailsPageBreadcrumbsPath: Function;
  getDetailsContractMrh: Function;
  contractsMrh: [];
  selectedTabValue: number;
  getContractsMrh: Function;
  getFaq: Function;
  faqMrh: [];
}) => {
  const language = useSelector(getLocaleSelector);

  useEffect(() => {
    props.getContractsMrh();
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    props.getFaq(language);
    // eslint-disable-next-line
  }, [language]);

  const firstContractNumber = get(props.contractsMrh, '[0].contractNumber');

  useEffect(() => {
    props.getDetailsContractMrh({
      policyNumber: firstContractNumber,
    });
    // eslint-disable-next-line
  }, [firstContractNumber, language]);

  const HeaderTextBloc = (
    <>
      <StyledMediumSectionHeader>
        {translate(get(messages, 'title'), props)}
      </StyledMediumSectionHeader>
    </>
  );
  return (
    <DetailPageLayout
      headerImage={get(AssuranceIcon, 'headerMRH')}
      HeaderTextBloc={HeaderTextBloc}
      Breadcrumbs={<Breadcrumbs path={props.detailsPageBreadcrumbsPath} />}
      TabsBloc={
        <ContainerTabs
          tabItems={tabItems}
          setBreadcrumbsPath={props.setMrhDetailsPageBreadcrumbsPath}
          rootPath={[{ name: 'habitation', route: pages.MRHDASHBOARD }]}
          selectedTabValue={props.selectedTabValue}
        />
      }
      CompensationServicesBloc={<PreventionGuide />}
      FAQBloc={
        <FrequentlyAskedQuestions
          items={
            props.faqMrh &&
            props.faqMrh.map(
              (
                item: { question: string; code: string; id: number },
                index: number,
              ) => ({
                title: (
                  <StyledShortBody
                    weight="bold"
                    color={sanlamDarkBlue}
                    key={index}
                  >
                    {item.question}
                  </StyledShortBody>
                ),
                isFaq: true,
                id: item.id,
                code: item.code,
                path: pages.FAQ,
              }),
            )
          }
          GACategoryAllResponses={EVENT_CATEGORIES.MRH_DETAILS}
        />
      }
      ServiceBloc={<ServicesBlock />}
      MyOffersBloc={<MyOffersBloc />}
    />
  );
};

const mapStateToProps = createStructuredSelector<
  any,
  {
    detailsPageBreadcrumbsPath: breadcrumbsItemType[];
    contractsMrh: any;
    selectedTabValue: number;
    faqMrh: [];
  }
>({
  detailsPageBreadcrumbsPath: getMrhDetailsPageBreadcrumbsPathSelector,
  contractsMrh: getContractsMrhSelector,
  selectedTabValue: getMrhDetailsPageSelectedTabValue,
  faqMrh: getMrhFaqSelector,
});

const mapDispatchToProps = {
  setMrhDetailsPageBreadcrumbsPath,
  getDetailsContractMrh,
  getContractsMrh,
  getFaq,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(MRHDetailsPage));

export { MRHDetailsPage as MRHDetailsPageTest };
